/* 平台下单 */
<template>
    <div id="orderForm">
        <div class="orderForm-content">
            <div class="orderForm-title">订单信息</div>
            <el-form :model="form" :rules="rules" size="medium" ref="form" label-width="100%" label-position="left">
                <el-form-item label="线路名称" prop="lineId">
                    <el-select v-model="form.lineId" placeholder="请选择线路名称" filterable @change="lineChange">
                        <el-option v-for="item in travelLineList" :key="item.id"
                            :label="item.startStationName + ' - ' + item.endStationName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上车位置" prop="startAddress" v-if="form.lineId">
                    <span style="font-size: 14px"
                        v-if="startStationRail.length == 1 && startStationRail[0].stationType == 1">{{
                            startAddress }}</span>
                    <el-button v-else @click="changeAddress(1)" type="text">
                        {{ startAddress ? startAddress : "点击选择" }}
                    </el-button>
                </el-form-item>

                <el-form-item label="下车位置" prop="endAddress" v-if="form.lineId">
                    <span style="font-size: 14px"
                        v-if="endStationRail.length == 1 && endStationRail[0].stationType == 1">{{
                            endAddress }}</span>
                    <el-button v-else @click="changeAddress(2)" type="text">
                        {{ endAddress ? endAddress : "点击选择" }}
                    </el-button>
                </el-form-item>

                <el-form-item>
                    <el-form-item label="用车时间" prop="orderTime" style="width: 49%; display: inline-block;">
                        <el-date-picker v-model="form.orderTime" format="yyyy-MM-dd" type="date" placeholder="请选择用车日期"
                            :picker-options="pickerOptions" />
                    </el-form-item>
                    <el-form-item label="" prop="orderDate" style="width: 49%;margin-left: 8px; display: inline-block;">
                        <el-time-select placeholder="请选择用车时间" v-model="form.orderDate" :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '23:45'
                        }">
                        </el-time-select>
                    </el-form-item>
                </el-form-item>

                <el-form-item>
                    <el-form-item label="联系信息" prop="contactPerson" style="width: 49%; display: inline-block;">
                        <el-input placeholder="请输入联系人姓名" v-model="form.contactPerson" :maxlength="10" />
                    </el-form-item>
                    <el-form-item label="" prop="contactPhone"
                        style="width: 49%;margin-left: 8px; display: inline-block;">
                        <el-input placeholder="请输入联系人电话" v-model="form.contactPhone" :maxlength="11" />
                    </el-form-item>
                </el-form-item>

                <el-form-item>
                    <el-form-item label="乘车人数" prop="passengerNum" style="width: 49%; display: inline-block;">
                        <el-radio-group v-model="form.passengerNum" style="width: 100%;">
                            <el-radio-button label="1"></el-radio-button>
                            <el-radio-button label="2"></el-radio-button>
                            <el-radio-button label="3"></el-radio-button>
                            <el-radio-button label="4"></el-radio-button>
                            <el-radio-button label="5"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="" prop="poolType" style="width: 49%;margin-left: 8px; display: inline-block;">
                        <el-radio-group v-model="form.poolType" style="width: 100%;">
                            <el-radio-button v-for="item in $const.LYPOOLTYPE" :key="item.value" :label="item.value">{{
                                item.label }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-form-item>

                <el-form-item>
                    <el-checkbox v-model="form.needTransfer">接送站服务</el-checkbox>
                    <div class="tip-text">勾选后该订单即需填写航班/班次号</div>
                </el-form-item>

                <div class="traffic-row" v-if="form.needTransfer">
                    <el-form-item label="交通方式" class="traffic-type" label-width="100%" prop="trafficType">
                        <el-radio-group v-model="form.trafficType" style="width: 100%;">
                            <el-radio-button label="航班"></el-radio-button>
                            <el-radio-button label="列车"></el-radio-button>
                            <el-radio-button label="汽车"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="航班/班次号" label-width="120px" class="traffic-no" prop="trafficNo">
                        <el-input placeholder="请输入" :maxlength="10" :value="form.trafficNo"
                            @input="trafficInput"></el-input>
                    </el-form-item>
                </div>

                <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.remark" placeholder="请输入100字内的备注" :maxlength="100"
                        show-word-limit :rows="4"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <div class="orderForm-footer">
            <el-button size="medium" type="primary" @click="saveClick" :loading="loading">确定</el-button>
        </div>

        <chooseMap v-if="mapVisible" :visible.sync="mapVisible" :address.sync="mapAddress" :type="mapType"
            :startStationRail="startStationRail" :endStationRail="endStationRail" :startId.sync="startId"
            :endId.sync="endId" @confirm="mapConfirm" />
    </div>
</template>

<script>
import chooseMap from "../reservation/chooseMap.vue";

export default {
    components: { chooseMap },
    name: "orderForm",
    props: {
        copyPhone: {
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            travelLineList: [],
            orderId: this.$route.query.orderId,
            stationList: [],
            startStationRail: [],
            endStationRail: [],
            startId: null,
            endId: null,

            mapVisible: false,
            mapType: 1,
            mapAddress: {},
            // 表单
            initialForm: {
                lineId: '',
                orderTime: '',
                orderDate: '',
                address: [{ type: 1 }, { type: 2 }],
                contactPerson: '',
                contactPhone: '',
                passengerNum: '',
                poolType: 2,
                needTransfer: false,
                trafficType: '',
                trafficNo: '',
                remark: ''
            },
            form: {}, // 将在 created 中初始化
            // 校验规则
            rules: {
                lineId: [{ required: true, message: "请选择线路名称" }],
                orderTime: [{ required: true, message: "请选择用车日期" }],
                orderDate: [{ required: true, message: "请选择用车时间" }],
                startAddress: [{ required: true, message: "请选择上车位置" }],
                endAddress: [{ required: true, message: "请选择下车位置" }],
                contactPerson: [{ required: true, message: "请输入联系人姓名" }],
                contactPhone: [{ required: true, message: "请输入联系人电话" }, {
                    validator: (rule, value, callback) => {
                        if (!/^1[3-9]\d{9}$/.test(value)) {
                            callback(new Error("请输入正确的手机号码"));
                        } else {
                            callback();
                        }
                    }, trigger: 'blur'
                }],
                passengerNum: [{ required: true, message: "请选择乘车人数" }],
                poolType: [{ required: true, message: "请选择是否需要包车" }],
                trafficType: [{ required: true, message: "请选择交通方式" }],
                trafficNo: [{ required: true, message: "请输入航班/班次号" }],
            },
            loading: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 86400000; // 禁用今天之前的日期
                }
            },
        };
    },
    computed: {
        /* 是否显示地图上围栏相关的操作按钮 */
        startAddress() {
            let item = this.form.address.find((item) => item.type == 1);
            let name = item.name;
            this.$set(this.form, "startAddress", name);
            return name;
        },
        endAddress() {
            let item = this.form.address.find((item) => item.type == 2);
            let name = item.name;
            this.$set(this.form, "endAddress", name);
            return name;
        }
    },
    watch: {
        'form.needTransfer'(newVal) {
            if (!newVal) {
                // 取消勾选时重置交通方式和班次号
                this.form.trafficType = '';
                this.form.trafficNo = '';
            }
        }
    },
    created() {
        this.form = JSON.parse(JSON.stringify(this.initialForm))
        this.getTravelLineList()
    },
    methods: {
        async getTravelLineList() {
            let url = '/api/v1/manage/travelLine'
            let { code, data } = await this.$axios.get(url)
            if (code == 1) {
                this.travelLineList = data
            } else {
                this.travelLineList = []
            }
        },
        trafficInput(value) {
            if (this.form.trafficType == '列车' || this.form.trafficType == '航班') {
                value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            } else {
                value = value.replace(/[^a-zA-Z0-9.\u4e00-\u9fa5]/g, '').toUpperCase();
            }
            this.form.trafficNo = value
        },
        lineChange(value) {
            this.$set(this.form, 'startAddress', {})
            this.$set(this.form, 'endAddress', {})
            this.$set(this.form, 'address', [{ type: 1 }, { type: 2 }])
            if (!value) {
                return
            }
            this.getStationList()
        },
        /* 获取站点信息 */
        async getStationList() {
            let url = "/api/v1/manage/travelOrder/line/station";
            let { code, data } = await this.$axios.get(url, {
                travelLineId: this.form.lineId
            });
            if (code == 1) {
                this.stationList = data;
                this.startStationRail = data.filter(item => item.type == 1);
                this.endStationRail = data.filter(item => item.type == 2);
                this.startId = this.startStationRail[0].id;
                this.endId = this.endStationRail[0].id;
                if (this.startStationRail.length == 1 && this.startStationRail[0].stationType == 1) {
                    let obj = {
                        type: 1,
                        stationType: this.startStationRail[0].stationType,
                        city: this.startStationRail[0].city,
                        longitude: this.startStationRail[0].longitude,
                        latitude: this.startStationRail[0].latitude,
                        name: this.startStationRail[0].stationName,
                        address: this.startStationRail[0].stationAddress,
                    };
                    this.$set(this.form, "startAddress", obj);
                    this.$set(this.form.address, 0, obj);
                }
                if (this.endStationRail.length === 1 && this.endStationRail[0].stationType == 1) {
                    let obj = {
                        type: 2,
                        stationType: this.endStationRail[0].stationType,
                        city: this.endStationRail[0].city,
                        longitude: this.endStationRail[0].longitude,
                        latitude: this.endStationRail[0].latitude,
                        name: this.endStationRail[0].stationName,
                        address: this.endStationRail[0].stationAddress,
                    };
                    this.$set(this.form, "endAddress", obj);
                    this.$set(this.form.address, 1, obj);
                }

            }
        },
        changeAddress(mapType) {
            if (!this.form.lineId) {
                this.$message.warning('请先选择线路名称')
                return
            }
            this.mapType = mapType;
            this.mapVisible = true;
            this.mapAddress = this.form.address
                ? this.form.address.find((item) => item.type == mapType)
                : {};
        },



        mapConfirm(obj) {
            this.form.address = this.form.address.map((item) => {
                if (item.type == this.mapType) {
                    item = obj;
                }
                return item;
            });

            this.$set(this.form, this.mapType == 1 ? "startAddress" : "endAddress", obj);
            this.$refs.form.validateField(this.mapType == 1 ? "startAddress" : "endAddress");

        },

        /* 点击保存 */
        saveClick() {
            console.log('this.form', this.form);
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let time = `${this.$utils.timeFn(this.form.orderTime, 'YYYY-MM-DD')} ${this.form.orderDate}`
                    let timeStamp = new Date(time).getTime() / 1000

                    let params = {
                        lineId: this.form.lineId,
                        startPointName: this.form.address[0].name,
                        endPointName: this.form.address[1].name,
                        startPointLng: this.form.address[0].longitude,
                        startPointLat: this.form.address[0].latitude,
                        endPointLng: this.form.address[1].longitude,
                        endPointLat: this.form.address[1].latitude,
                        orderTime: timeStamp,
                        contactPerson: this.form.contactPerson,
                        contactPhone: this.form.contactPhone,
                        passengerNum: this.form.passengerNum,
                        poolType: this.form.poolType,
                        trafficType: this.form.trafficType,
                        trafficNo: this.form.trafficNo,
                        remark: this.form.remark,
                    }
                    this.postFn(params);
                }
            });
        },

        /* 接口请求-提交 */
        async postFn(params) {
            this.loading = true;
            let url = "/api/v1/manage/travelOrder/order/create"
            let { code } = await this.$axios.post(url, params)
            if (code === 1) {
                // 重置表单到初始状态
                this.form = JSON.parse(JSON.stringify(this.initialForm))
                this.$nextTick(() => {
                    this.$refs.form.clearValidate()
                })
                this.$message.success("下单成功")
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="less" scoped>
#orderForm {
    height: calc(100vh - 48px) !important;
    padding: 20px 0 !important;
    box-sizing: border-box;
    color: black;
    display: flex;
    flex-flow: column;
    align-items: center;
    overflow-y: hidden;

    &>* {
        width: 600px;
        padding: 20px !important;
        margin-top: 0 !important;
        border-radius: 20px;
        background-color: white;
        box-sizing: border-box;
    }

    .orderForm-content {
        margin-bottom: 16px !important;
        box-sizing: border-box;
        flex: 1;
        overflow-y: auto;

        .orderForm-title {
            font-size: 20px;
            font-weight: bold;
        }

        .traffic-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            &>* {
                flex: 1;
            }
        }

        // 滚动条
        &::-webkit-scrollbar {
            width: 0;
        }
    }

    .orderForm-footer {
        text-align: right;
    }

    /deep/ .el-radio-group {
        display: flex;
        flex-wrap: nowrap;
    }
    .el-radio__label {
    display: none;
  }

    /deep/ .el-radio-button {
        flex: 1;
        flex-shrink: 1;
    }

    /deep/ .el-radio-button__inner {
        width: 100% !important;
    }

    .tip-text {
        font-size: 12px;
        color: #999;
        margin-left: 24px;
    }
}
</style>
